import { useField } from "formik";
import React from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { ErrorM } from "components/helpers/ErrorM";

type Props = {
  field: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean;
  datePickerProps?: Partial<ReactDatePickerProps>;
};

export const FormDateField = ({
  field,
  label,
  placeholder,
  required,
  error,
  datePickerProps,
}: Props) => {
  const [formikProps, formikMeta, formikHelpers] = useField(field);

  const userLocale = "en-US";
  return (
    <div className="FormBox FormSideBySide">
      <div className="DatePickerFormLabel FormLabel">
        <label>{label}</label>
      </div>
      <div className="DatePickerFormField FormField">
        <DatePicker
          locale={userLocale}
          className={`DatePickerBox DatePickerBox1 EditBox ${
            formikMeta.error && formikMeta.touched ? "ErrorInput" : ""
          }`}
          placeholderText={placeholder}
          onBlur={e => {
            formikHelpers.setTouched(true);
          }}
          selected={formikProps.value ? new Date(formikProps.value) : undefined}
          onChange={value => formikHelpers.setValue(value)}
          required={required}
          {...datePickerProps}
        />
      </div>
      <ErrorM name={field} />
    </div>
  );
};
